<!--下拉 DLQ-->
<template>
  <div class="question-container" style="border: 1px solid #edeff2">
    <div class="question-type">下拉</div>
    <div class="title-view" :style="{ marginRight: '' }">
      <!-- <p style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        {{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、` }}
        <span style="color: #4c4a56">
          {{ `${dataObj.caseProblem}` }}
        </span>
      </p> -->
      <p class="question-row">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        <span class="index">{{
          `${dataObj.questionIndex || index + 1}、`
        }}</span>

        <!-- 富文本 + 后缀文字 放在同一个容器里 -->
        <span class="rich-text-wrapper">
          <span class="rich-text-content" v-html="dataObj.caseProblem"></span>
        </span>
      </p>
    </div>
    <div class="question-images">
      <div
        v-for="(item, index) in images"
        :key="index"
        style="margin-top: 10px; position: relative"
      >
        <img :src="item" mode="widthFix" style="width: 100%" />
      </div>
    </div>
    <el-select
      v-if="operate === 'answer'"
      v-model="value"
      placeholder="请选择"
      style="
        width: 100%;
        margin-top: 12px;
        border: 1px solid #ededed;
        border-radius: 3px;
      "
      @change="handleChoose"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <div v-else class="select-view">
      <p style="font-size: 14px; color: #2b2f36; word-break: break-all">
        {{ value || "请选择" }}
      </p>
      <i class="el-icon-arrow-down" size="16px"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: {},
    },
    operate: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dataObj: {},
      index: 0,
      list: [],
      images: [],
      selectedText: "",
      options: [],
      value: "",
    };
  },
  methods: {
    handleChoose(event) {
      console.log(event);
      this.value = event;
      console.log("平日平日平日平日票让人心跳", this.list);
      this.dataObj.chooseList = JSON.stringify({
        list: this.list.map((item) => {
          return {
            id: item.id,
            text: item.text,
          };
        }),
        value: this.list.find((item) => item.id === event).text,
      });
      this.$emit(
        "update",
        JSON.stringify({
          data: this.dataObj,
          answer: {
            question_id: this.dataObj.id,
            type: this.dataObj.type,
            if_hide: this.dataObj.if_hide,
            answer: [
              {
                id: event,
                context: this.list.find((item) => item.id === event).text,
              },
            ],
          },
          index: this.index,
        }),
      );
    },
  },
  watch: {
    params: {
      handler(newVal) {
        console.log(newVal, "newValsadasdasdas");
        this.dataObj = newVal.data;
        this.index = newVal.index;
        this.images = JSON.parse(newVal.data.caseProblemImg || "[]");
        this.list = JSON.parse(newVal.data.chooseList).list || [];

        this.options = this.list.map((item) => ({
          value: item.id,
          label: item.text,
        }));

        if (
          JSON.parse(newVal.data.chooseList).value === "" ||
          JSON.parse(newVal.data.chooseList).value === undefined ||
          JSON.parse(newVal.data.chooseList).value === null
        ) {
          // state.value = JSON.parse(newValue.data.chooseList).list[0].text
          this.value = "请选择您的选项";
        } else {
          this.value = JSON.parse(newVal.data.chooseList).value;
        }

        console.log(this.list, "we239eu293r3209r2390r2390");
        console.log(this.options, "4694576495067450967450967450");

        // if (
        //   newVal.answer &&
        //   Array.isArray(newVal.answer.answer) &&
        //   newVal.answer.answer.length
        // ) {
        //   const answer = newVal.answer.answer[0];
        //   const selectedItem = this.list.find((item) => item.id === answer.id);
        //   this.value = selectedItem ? selectedItem.text : "";
        // } else {
        //   this.value = "";
        // }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.select-view {
  width: 100%;
  min-height: 44px;
  background-color: #f9f9f9;
  border-radius: 3px;
  margin-top: 12px;
  padding: 0 12px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #ededed;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewDLQ.vue